import { Loading } from "@mostrans/web-components/components/base/Loading";

function LoadingFallback() {
    return (
        <div
            className="d-grid place-items-center"
            style={{
                height: "min(50vh,500px)",
                maxHeight: "100%",
                width: "100%",
            }}
        >
            <Loading />
        </div >
    );
}

export default LoadingFallback;
